var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    role: "img",
    "aria-label": "Agent avatar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a56db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c3aed"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 20,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,18)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 18,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 86c4-18 24-22 32-22s28 4 32 22H8z",
    opacity: 0.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentBot);
export default __webpack_public_path__ + "static/media/agent-bot.75ea58b61ccce21c3c52be004065cd6f.svg";
export { ForwardRef as ReactComponent };